import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {Utilities} from '@shared/utilities/utilities.model';
import {MatDialogRef} from '@angular/material/dialog';
import {MatInput} from '@angular/material/input';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-paper-sign-motivation-dialog',
	templateUrl: './paper-sign-motivation-dialog.component.html',
	styleUrls: ['./paper-sign-motivation-dialog.component.scss']
})
export class PaperSignMotivationDialogComponent implements OnInit {
	@ViewChild(MatInput) inputCustomReason: MatInput;
	@ViewChild('reason_one') reasonOne: ElementRef;
	@ViewChild('reason_two') reasonTwo: ElementRef;
	@ViewChild('reason_three') reasonThree: ElementRef;

	selected: number = -1;
	customReason: string = null;
	inputCustomReasonPlaceholder: string = null;
	inputCustomReasonDirty: boolean = false;
	inputCustomReasonTouched: boolean = false;
	translateContext = TranslateContext;

	constructor(
		public dialogRef: MatDialogRef<PaperSignMotivationDialogComponent>) {
	}

	ngOnInit(): void {
	}

	onClick(event: boolean): void {
		if (event) {
			let txtMessage: string = 'Motivo scelta firma cartacea:' + ' ';
			switch (this.selected) {
				case 0:
					txtMessage += this.reasonOne.nativeElement.innerHTML;
					break;
				case 1:
					txtMessage += this.reasonTwo.nativeElement.innerHTML;
					break;
				case 2:
					txtMessage += this.reasonThree.nativeElement.innerHTML;
					break;
				case 3:
					txtMessage += this.customReason;
					break;
			}
			this.dialogRef.close({
				txt_message: txtMessage
			});
		} else {
			this.dialogRef.close(null);
		}
	}

	onChangeRadioGroup(event: any): void {
		if (this.selected !== 3) {
			this.customReason = null;
			this.inputCustomReasonDirty = false;
			this.inputCustomReasonTouched = false;
		}
	}

	onFocusInputCustomReason(event: any): void {
		this.inputCustomReasonDirty = true;
		if (!!this.inputCustomReason) {
			if (Utilities.isVoid(this.inputCustomReasonPlaceholder)) {
				this.inputCustomReasonPlaceholder = this.inputCustomReason.placeholder;
			}
			this.inputCustomReason.placeholder = null;
		}
	}

	onBlurInputCustomReason(event: any): void {
		this.inputCustomReasonTouched = true;
		if (!Utilities.isVoid(this.inputCustomReason) && (Utilities.isVoid(this.customReason) || this.customReason.length === 0)) {
			this.inputCustomReason.placeholder = this.inputCustomReasonPlaceholder;
		}
	}

}
